import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {CSSProperties} from "react";

import {StaticRow} from "../StaticRow/StaticRow";
import {DraggableRowProps} from "./DraggableRow.types";

export const DraggableRow = <TData,>({
  row,
  subrowRenderer,
  expandableSubRows,
  addEndSpacer,
  tableRowOnClick,
  tableRowClassName,
}: DraggableRowProps<TData>) => {
  const {transform, transition, setNodeRef, isDragging} = useSortable({
    id: row.id,
    data: row,
  });

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition,
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 1 : 0,
    position: isDragging ? "relative" : "static",
  };

  return (
    <StaticRow
      row={row}
      subrowRenderer={subrowRenderer}
      expandableSubRows={expandableSubRows}
      addEndSpacer={addEndSpacer}
      tableRowOnClick={tableRowOnClick}
      tableRowClassName={tableRowClassName}
      rowRef={setNodeRef}
      rowStyle={style}
    />
  );
};
